export default __webpack_public_path__ + "static/media/m1938.cef849e3.svg";